import Vue from "vue";

const state =  {
 logdata :[]
}

const getters = {
    getLogs(state){
        return state.logdata
    },
}

const mutations = {
    updateLogs(state, islem){
        state.logdata.push(islem);
    },
}

const actions = {
    initCompany({ commit }){
        state.company = [];
         Vue.http.get("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/logs.json")
         .then(response =>{
             let data = response.body;
             for(let key in data){
                 data[key].key = key;
                 commit("updateLogs", data[key]);
                 console.log(response.body)
             }
         })
    },

    saveLog({ commit, state }, payload){
       let log = {
            date: new Date,
            kullanici: localStorage.getItem("usermail"),
            islem : payload.name + payload.islem
        }
        Vue.http.post("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/logs.json", log)
        .then((response) => {

            console.log(response)


        })
   },

}


export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/log.js